

export function getToken() {
  return localStorage.getItem("token");
}

export function Logout() {
  localStorage.removeItem("token");
  window.location.href = "/login"; 
}

export function getTokenExpiry(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000; // convert to ms
  } catch (e) {
    return null;
  }
}
